import { AnalysisProgress } from '@/common/model/recommend/aiTag'

import LoadingObject, { LoadingObjectType } from '@/components/view/atoms/loading/LoadingObject'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import AiInsideArea from '@/components/view/layouts/area/AiInsideArea'
import AreaContent from '@/components/view/layouts/area/AreaContent'

interface Props {
  analyzing: boolean
  progress: AnalysisProgress | null
  analyzeMsg: string
}

const AITagProgressBar = ({ analyzing, progress, analyzeMsg }: Props) => {
  const showProgress = analyzing || (progress && progress.status !== 'idle')

  if (!showProgress && !analyzeMsg) return null

  if (!showProgress && analyzeMsg) {
    return (
      <AiInsideArea border>
        <AreaContent>
          <Text size={14}>{analyzeMsg}</Text>
        </AreaContent>
      </AiInsideArea>
    )
  }

  const isSpinning =
    progress?.status === 'analyzing' ||
    progress?.status === 'starting' ||
    progress?.status === 'saving'

  const progressPercent =
    progress && progress.total > 0
      ? Math.round(((progress.processed || 0) / progress.total) * 100)
      : 0

  return (
    <AiInsideArea border>
      {progress && progress.total > 0 && (
        <AreaContent>
          <div className='mb-1 flex justify-between'>
            <Text size={10} color={TextColor.SECONDARY}>
              {progress.processed || 0} / {progress.total} アイテム
            </Text>
            <Text size={10} color={TextColor.SECONDARY}>
              {progress.tags_found || 0} タグ抽出済
            </Text>
          </div>
          <div className='bg-fill-tertiary h-1.5 overflow-hidden rounded-full'>
            <div
              className={`h-full rounded-full transition-all duration-500 ${
                progress.status === 'completed'
                  ? 'bg-success'
                  : progress.status === 'error'
                    ? 'bg-critical'
                    : 'bg-fill-brand'
              }`}
              style={{ width: `${progressPercent}%` }}
            />
          </div>
        </AreaContent>
      )}
      <div className='flex flex-col gap-4 p-4'>
        <LoadingObject type={LoadingObjectType.TEXT} />
        <LoadingObject type={LoadingObjectType.TEXT} />
        <LoadingObject type={LoadingObjectType.TEXT} />
      </div>
    </AiInsideArea>
  )
}

export default AITagProgressBar
